import { createSlice } from '@reduxjs/toolkit';
import { handleGetGoogleSearch } from './googleThunk';
import { ICommonSearchItem } from '~/utils/interface/commonField';

export interface GoogleState {
  options: Array<ICommonSearchItem>;
}

const initialState: GoogleState = {
  options: [],
};

const googleSlice = createSlice({
  name: 'google',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(handleGetGoogleSearch.fulfilled, (state, action) => {
      state.options = action.payload;
    });
  },
});

export const googleActions = googleSlice.actions;

const googleReducer = googleSlice.reducer;
export default googleReducer;
